import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk to handle subscription API call
export const subscribeUser = createAsyncThunk(
  "subscribe/subscribeUser",
  async (email, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/subscribe/`,
        { email_id: email },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const { success, message } = response.data;

      if (success) {
        return { email, message }; // Return email and success message
      } else {
        return rejectWithValue(message); // Reject with backend message (e.g., "Email already subscribed")
      }
    } catch (error) {
      return rejectWithValue("Subscription failed. Try again.");
    }
  }
);

const initialState = {
  subscribedEmails: [], // Array to store all subscribed emails
  lastSubscribedEmail: null, // Store the last subscribed email for pre-filling
  status: "idle",
  error: null,
  isSubscribed: false,
};

const subscribeSlice = createSlice({
  name: "subscribe",
  initialState,
  reducers: {
    clearSubscribedEmails(state) {
      state.subscribedEmails = [];
      state.lastSubscribedEmail = null;
      state.isSubscribed = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(subscribeUser.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(subscribeUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        const email = action.payload.email;
        if (!state.subscribedEmails.includes(email)) {
          state.subscribedEmails.push(email); // Add to subscribed emails if not already present
        }
        state.lastSubscribedEmail = email; // Set as last subscribed email
        state.isSubscribed = true;
        state.error = null;
      })
      .addCase(subscribeUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload; // Set error message from backend (e.g., "Email already subscribed")
      });
  },
});

export const { clearSubscribedEmails } = subscribeSlice.actions;
export default subscribeSlice.reducer;